import { keepPreviousData, useQuery } from '@tanstack/react-query';
import API, { requestTemplatesApiUrl as TemplateQK } from './api';
import { ResponseType } from 'src/constants/data';

export const useGetTemplateCategories = () => {
  return useQuery({
    queryKey: [TemplateQK, ResponseType.List],
    queryFn: () => API.getTemplateCategories(),
    placeholderData: keepPreviousData
  });
};

export const useGetTemplates = (id?: string) => {
  return useQuery({
    queryKey: [TemplateQK, ResponseType.List, id],
    queryFn: () => API.getTemplates(id),
    placeholderData: keepPreviousData,
    enabled: !!id
  });
};
